module.exports = __webpack_public_path__ + "img/Z86Q_11.8a8b93dd.jpg";